import { MESSAGES } from '../../../constants';
import { getLast, isUndefined } from '../../../util/guards';
import { TItem } from './types';

const findModeMessage = (items: TItem[]): number => {
  let i = items.length;

  while (0 < i--) {
    const item = items[i];

    if (item.type === MESSAGES.CHANGE_MODE) {
      if (item.isLiveChat) {
        return i;
      } else {
        break;
      }
    }
  }

  return -1;
};

export const concatItems = (items: TItem[], item: TItem): TItem[] => {
  /**
   * If the message list has the user message with the same ID
   * that the new item then we don't need update message list
   * (That means it's a master tab)
   */
  if (item.type === MESSAGES.USER_MESSAGE) {
    const index = items.findIndex((i) => i.id === item.id);

    if (index > -1) {
      // We don't need to update items of chat messages
      return items;
    }
  }

  // Remove all messages with mark for removing
  const filteredItems = items.filter((i) => !i.rm);

  /**
   * When agent is join to live chat, then we remove the bot message:
   * "Waiting for an expert to join the chat…"
   */
  if (item.type === MESSAGES.AGENT_STATUS) {
    const modeMessagesRemoved = false;
    while (!modeMessagesRemoved) {
      const removeIndex = findModeMessage(filteredItems);
      if (removeIndex === -1) {
        break;
      }

      filteredItems.splice(removeIndex, 1);

      const previousIndex = removeIndex - 1;
      const previousMessage = filteredItems[previousIndex];

      if (!isUndefined(previousMessage)) {
        const updatedPrevious = { ...previousMessage, avatar: true };

        filteredItems.splice(previousIndex, 1, updatedPrevious);
      }
    }
  }

  const last = getLast(filteredItems);

  /**
   * If the last message has the same role
   * that a new message then remove avatar
   */
  if (!isUndefined(last) && last.role === item.role) {
    const updatedLast = { ...last, avatar: false };

    filteredItems.splice(-1, 1, updatedLast);
  }

  filteredItems.push(item);

  return filteredItems;
};

export const changeMessage = (items: TItem[]): TItem[] => {
  const last = getLast(items);

  /**
   * if the last message in the chat has `rm` flag (be able to remove)
   * we have to remove all message from this conversation node
   */

  if (!isUndefined(last) && last.rm === true && 'nodeId' in last) {
    let i = items.length - 2;

    while (i >= 0) {
      const item = items[i];

      if ('nodeId' in item && item.nodeId === last.nodeId) {
        i--;
      } else {
        break;
      }
    }

    return items.slice(0, i + 1);
  }

  return items;
};

export const disableChangeFeature = (items: TItem[]): TItem[] => {
  items.forEach((item, index) => {
    if ('disabled' in item) {
      items.splice(index, 1, { ...item, disabled: true });
    }
  });

  return items.slice();
};

export const omit = <T>(obj: T, id: string) => {
  const res: Partial<T> = {};

  for (const key in obj) {
    if (key !== id) {
      res[key] = obj[key];
    }
  }

  return res;
};
